import React from 'react'
import PropTypes from 'prop-types'
import styles from './TagLabel.icss'

class TagLabel extends React.Component {
	render() {
		const { arrowDown, isUserLabel, children, className, ...rest } = this.props
		return (
			<div className={[arrowDown ? styles.tagLabelArrowDown : styles.tagLabel, isUserLabel ? styles.userLabel : undefined, className].join(' ')} {...rest}>
				<span className={styles.tagLabelContents}>{children}</span>
			</div>
		)
	}
}

TagLabel.propTypes = {
	children: PropTypes.node.isRequired,
	/* eslint-disable-next-line react/forbid-prop-types */
	style: PropTypes.object,
	arrowDown: PropTypes.bool,
	isUserLabel: PropTypes.bool,
	className: PropTypes.string
}

TagLabel.defaultProps = {
	style: null,
	arrowDown: false,
	isUserLabel: false,
	className: undefined
}

export default TagLabel



// WEBPACK FOOTER //
// ./src/components/TagLabel.jsx